import React, { useMemo } from 'react';
import {
  AllTransactionsHistory,
  ExchangeTransactionsHistory,
  IssueTransactionsHistory,
  PurchaseTransactionsHistory,
  SaleTransactionsHistory,
  RedeemTransactionsHistory,
} from '../../components/transaction-history';
import { RestoreKeysTab, CompanyVerificationsTab } from './components';
import PageHeader from '../../modules/page-header';
import { TabsContainer } from '@ru-digital-assets/ui-component';
import { useSelector } from 'hooks/redux';
import './history.scss';

const getHistoryTabs = (position: string) => {
  if (position === 'OPERATOR') {
    return [
      {
        name: 'Все операции',
        id: 'all',
        Component: AllTransactionsHistory,
      },
      // {
      //   name: 'Исполнение актов органов власти',
      //   id: 'acts',
      //   Component: () => <></>,
      // },
      {
        name: 'Восстановление Ключей',
        id: 'keys',
        Component: RestoreKeysTab,
      },
      {
        name: 'Подтверждение данных Пользователей',
        id: 'companies',
        Component: CompanyVerificationsTab,
      },
    ];
  } else {
    return [
      {
        name: 'Все операции',
        id: 'all',
        Component: AllTransactionsHistory,
      },
      {
        name: 'Продажа',
        id: 'sale',
        Component: SaleTransactionsHistory,
      },
      {
        name: 'Покупка',
        id: 'purchase',
        Component: PurchaseTransactionsHistory,
      },
      {
        name: 'Выпуск',
        id: 'issue',
        Component: IssueTransactionsHistory,
      },
      {
        name: 'Обмен',
        id: 'exchange',
        Component: ExchangeTransactionsHistory,
      },
      {
        name: 'Погашение',
        id: 'redeem',
        Component: RedeemTransactionsHistory,
      },
    ];
  }
};

const History: React.FC = () => {
  const position = useSelector((state) => state.auth.profile.position);
  const tabs = useMemo(() => getHistoryTabs(position), [position]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-19S col-lg-27 col-xl-35">
          <PageHeader
            items={[{ link: '', title: 'Операции' }]}
            iconType="history"
            isHideBalanceInformer={position === 'OPERATOR'}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-19S col-lg-27 col-xl-35">
          <div className="history-tabs">
            <TabsContainer
              tabs={tabs}
              tabsContainerClassName="table-wrapper"
              wrapper
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
